import ActionsForm from '@/shared/mixins/actionsForm'
import Draggable from 'vuedraggable'
import { loading, toast } from '@/shared/utils/UIHelper'

import BoardRepository from '@/shared/http/repositories/crm/board.js'
import BoardColumnRepository from '@/shared/http/repositories/crm/boardcolumn.js'
import ColumnEvents from './columnEvents'

export default {
  name: 'BoardCollumns',
  mixins: [ActionsForm],
  props: {
    board: {
      type: Object,
      default: null
    },
    boardColumns: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      columnEvents: ColumnEvents,
      boardName: null,
      localColumns: [],
      localBoard: [],
      localRemove: [],
      editing: {
        columnID: null,
        oldTitle: null,
        oldValue: null,
        oldColor: null,
        oldHoursUntilAlert: null,
        oldObservacao: null,
        oldObrigatorio: false
      }
    }
  },
  components: {
    Draggable
  },
  computed: {
    newIndexName () {
      let result = 1
      if (this.localColumns && this.localColumns.length > 0) {
        this.localColumns.forEach((el) => {
          result++
        })
      }
      return result
    }
  },
  beforeMount () {
    // this.localColumns = JSON.parse(JSON.stringify(this.columns))
    // this.localBoard = JSON.parse(JSON.stringify(this.board))
    this.editing.columnID = null
  },
  methods: {
    showModal () {
      this.onClear()
      this.boardName = this.board ? this.board.nome : null
      this.onSetLocalColumns()
      this.$refs['modal-column'].show()
    },
    hideModal () {
      this.$refs['modal-column'].hide()
    },
    onLoad () {
      this.onClear()
    },
    onMoveColumns () {
      let localColumns = []

      this.localColumns.map((column, index) => {
        column.position = index
        localColumns.push(column)
      })

      this.localColumns = localColumns
    },
    onAdd () {
      // this.localColumns.unshift({
      this.localColumns.push({
        id: parseInt('-' + this.newIndexName),
        boardId: this.board.id,
        name: 'Nova Coluna ' + this.newIndexName,
        color: 'blue',
        value: null,
        hoursUntilAlert: null,
        observacao: null,
        obrigatorio: false,
        eventoColuna: [ColumnEvents.SEM_ACAO]
      })
    },
    onSave () {
      this.editing.columnID = null
    },
    onEdit (column) {
      this.editing.columnID = column.id
      this.editing.oldTitle = column.title
      this.editing.oldValue = column.value
      this.editing.oldColor = column.color
      this.editing.oldHoursUntilAlert = column.hoursUntilAlert
      this.editing.oldObservacao = column.oldObservacao
      this.editing.oldObrigatorio = column.oldObrigatorio
    },
    onCancel (column) {
      column.title = this.editing.oldTitle
      column.value = this.editing.oldValue
      column.color = this.editing.oldColor
      column.hoursUntilAlert = this.editing.oldHoursUntilAlert
      column.oldObservacao = this.editing.oldObservacao
      column.oldObrigatorio = this.editing.oldObrigatorio

      this.$nextTick(() => {
        this.editing.columnID = null
        this.editing.oldHoursUntilAlert = null
        this.editing.oldObservacao = null
        this.editing.oldTitle = null
        this.editing.oldValue = null
        this.editing.oldColor = null
        this.editing.oldObrigatorio = false
      })
    },
    onRemove (column) {
      if (column.id && column.id > 0) {
        BoardColumnRepository.Delete(column.id)
          .then((response) => {
            if (response.status === 200) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.$emit('Back')
            }
          })
          .catch(this.onException)
      }
      let index = this.localColumns.findIndex(c => c.id === column.id)
      this.localColumns.splice(index, 1)
    },
    onSetLocalColumns () {
      this.localColumns = []
      this.boardColumns.forEach(element => {
        this.localColumns.push({
          id: element.id,
          boardId: element.board.id,
          name: element.nome,
          color: element.cor,
          value: element.percentual,
          hoursUntilAlert: element.hoursUntilAlert,
          observacao: element.observacao,
          obrigatorio: element.obrigatorio,
          eventoColuna: element.eventoColuna
        })
      })
    },
    async onSaveBoardColumn () {
      if (this.editing.columnID === null) {
        loading.push()
        let columnsCreate = []
        let columnsUpdate = []
        let i = 0
        this.localColumns.forEach(element => {
          if (element.id && element.id > 0) {
            columnsUpdate.push({
              'id': element.id,
              'boardId': element.boardId,
              'nome': element.name,
              'posicao': i,
              'cor': element.color,
              'hoursUntilAlert': element.hoursUntilAlert ? parseInt(element.hoursUntilAlert) : null,
              'percentual': element.value ? parseInt(element.value) : null,
              'observacao': element.observacao,
              'obrigatorio': element.obrigatorio,
              'eventoColuna': element.eventoColuna
            })
          } else {
            columnsCreate.push({
              'id': null,
              'boardId': element.boardId,
              'nome': element.name,
              'posicao': i,
              'cor': element.color,
              'hoursUntilAlert': element.hoursUntilAlert ? parseInt(element.hoursUntilAlert) : null,
              'percentual': element.value ? parseInt(element.value) : null,
              'observacao': element.observacao,
              'obrigatorio': element.obrigatorio,
              'eventoColuna': element.eventoColuna
            })
          }
          i++
        })
        if (this.board) {
          if (this.boardName !== this.board.nome) {
            await this.onUpdateBoard(this.boardName)
          }

          if (columnsCreate && columnsCreate.length > 0) {
            await this.onCreateBoardColumn(columnsCreate)
          }

          if (columnsUpdate && columnsUpdate.length > 0) {
            await this.onUpdateBoardColumn(columnsUpdate)
          }
          loading.pop()
          this.hideModal()
          this.$emit('Back')
        }
      } else {
        toast.warning('Salve ou cancele a edição da coluna para Finalizar!')
      }
    },
    async onCreateBoardColumn (columnsCreate) {
      if (columnsCreate.length > 0) {
        await BoardColumnRepository.CreateMany(columnsCreate)
          .then((response) => {
            if (response.status === 200) {
              toast.success(this.$lang.Common.Alerts.Success)
            }
          })
          .catch(this.onException)
      }
    },
    async onUpdateBoardColumn (columnsUpdate) {
      if (columnsUpdate.length > 0) {
        columnsUpdate.forEach(element => {
          BoardColumnRepository.Update(element)
            .then((response) => {
              if (response.status === 200) {
                toast.success(this.$lang.Common.Alerts.Success)
              }
            })
            .catch(this.onException)
        })
      }
    },
    async onUpdateBoard (name) {
      var result = false
      if (this.board) {
        this.board.nome = name
        await BoardRepository.Update(this.board)
          .then((response) => {
            if (response.status === 200) {
              result = true
            }
          })
          .catch(this.onException)
      }
      return result
    },
    onSetAction (column, index, eventoColuna) {
      let currentColumn = this.localColumns[index].eventoColuna

      // If user is removing the event
      if (currentColumn.some((event) => event === eventoColuna)) {
        currentColumn.splice(currentColumn.indexOf(eventoColuna), 1)

        // If eventsColumn gets empty
        if (currentColumn.length === 0) currentColumn.push(0)

        return
      }

      // If user is adding an event
      if (eventoColuna === 0) {
        currentColumn = [0]
      } else {
        currentColumn.some(event => event === 0)
          ? currentColumn.splice(0, 1, eventoColuna)
          : currentColumn.push(eventoColuna)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/board/modal/collumns/boardcollumns.js